/* eslint prefer-template: 0 camelcase: 0 */

import { connect } from 'react-redux'
import React, { Component } from 'react'

import ModalEmail from '../../components/comparison/modal_email/ModalEmail';
import AccordionGroupSet from '../../components/comparison/accordion/Accordion';
import ComparisonBar from '../../components/comparison/comparison_bar/ComparisonBar';

import { comparePlans } from '../../apiCalls'
import { setQuotationParams } from '../../actions/searchActions'

import { openModalQuotationDateWarning } from '../../actions/comparisonActions';
import { isMobile, getUrlParams, removeDuplicates, formatURL, changeTitle, isB2b } from '../../utils';
import ModalQuotationDateWarning from '../../components/common/modal_quotation_date_warning/ModalQuotationDateWarning';


class ComparisonAlert extends Component {
    render() {
        return (
            <main>
                <div className="comp_main clearfixs">
                    <section className="area-lista-comparacao">
                        <div className="component">
                            <h2 style={{ textAlign: 'center', color: '#007e47' }}>
                                É possível comparar apenas 2 produtos em telas pequenas.
                                Para ver todos os planos da comparação abra esta página em um dispositivo de tela maior!
                            </h2>
                        </div>
                    </section>
                </div>
            </main>
        )
    }
}

class Comparison extends Component {
    constructor(props) {
        super(props);

        changeTitle('comparison')

        const { products_ids } = getUrlParams();
        const products_ids_arr = products_ids.replace(/%20/g, '+').split('+')

        const unique_products_ids_arr = removeDuplicates(products_ids_arr)

        let basePath = '/seguro-viagem/comparacao';

        if (isB2b())
            basePath = '/seguro-viagem/comparacao-b2b';

        if (products_ids_arr.length !== unique_products_ids_arr.length) {
            const location = {
                pathname: formatURL(
                    this.props.match.params,
                    basePath + '/' + this.props.match.params.destination +
                    '/' + this.props.match.params.begin_date + '/' + this.props.match.params.end_date + '/',
                    window.location.search
                        .replace(/products_ids=[0-9,]+/, 'products_ids=' + unique_products_ids_arr.join('+'))
                )
            }
            this.props.history.push(location);
        }
    }

    componentWillMount() {

        if (isMobile() && getUrlParams().products_ids.replace(/%20/g, '+').split('+').length > 2)
            return;

        const { products_ids } = getUrlParams()

        comparePlans({
            destination: this.props.match.params.destination,
            begin_date: this.props.match.params.begin_date,
            end_date: this.props.match.params.end_date,
            product_code: products_ids,
        });

        setQuotationParams({
            context: 'comparison',
            product_code: products_ids,
            end_date: this.props.match.params.end_date,
            begin_date: this.props.match.params.begin_date,
            destination: this.props.match.params.destination,
        });
    }

    render() {
        if (isMobile() && getUrlParams().products_ids.replace(/%20/g, '+').split('+').length > 2)
            return <ComparisonAlert />
        if (!this.props.plans.length)
            return <div />

        return (
            <main>
                <div className="comp_main clearfixs">
                    <ComparisonBar destinations={this.props.destinations}/>
                    <AccordionGroupSet />
                    <ModalEmail type="comparison" />
                    <ModalQuotationDateWarning />
                </div>
            </main>
        )
    }
}

export default connect(
    state => ({
        plans: state.search.plans,
        isModalEmailActive: state.comparison.isModalEmailActive,
        userDetails: state.comparison.userDetails,
        destinations: state.global.destinations,
    }),
    {
        setQuotationParams,
        openModalQuotationDateWarning
    }
)(Comparison)



// WEBPACK FOOTER //
// ./src/views/comparison/Comparison.jsx